import { z } from 'zod';

export const sort = z.object({
  sorting: z
    .object({
      field: z.string(),
      sort: z.enum(['asc', 'desc']).nullable().optional(),
    })
    .optional(),
});

export type Sort = z.infer<typeof sort>;
